module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1138.9577f343.png";